// api
import { fetchApi } from '@/api'
// actions
const papeleriaProductsSubCategoriesAll = (context) => {
  let url = 'inventory/products/indexpapeleriaSubcategories'
  let data = {}
  return fetchApi(url, data, 'GET')
    .then((response) => {
      context.commit('PAPELERIA_PRODUCTS_SUBCATEGORIES_ALL', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const papeleriaProductsSubCategoriesForm = (context) => {
  let url = 'inventory/products/subcategories/createSubcPaper'
  let data = {}
  return fetchApi(url, data, 'GET')
    .then((response) => {
      context.commit('PAPELERIA_PRODUCTS_SUBCATEGORIES_FORM', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const papeleriaProductsSubCategoriesShow = (context, payload) => {
  let obj = JSON.parse(payload)
  let data = {}
  let url = 'inventory/products/subcategories/' + obj.id + '/edit'
  return fetchApi(url, data, 'GET')
    .then((response) => {
      context.commit('PAPELERIA_PRODUCTS_SUBCATEGORIES_SHOW', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const papeleriaProductsSubCategoriesCreate = (context, payload) => {
  let url = 'inventory/products/subcategories'
  return fetchApi(url, payload, 'POST')
    .then((response) => {
      context.commit('PAPELERIA_PRODUCTS_SUBCATEGORIES_CREATE', response)
      window.history.back()
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const papeleriaProductsSubCategoriesUpdate = (context, payload) => {
  let obj = JSON.parse(payload)
  let url = 'inventory/products/subcategories/' + obj.id
  return fetchApi(url, payload, 'PUT')
    .then((response) => {
      context.commit('PAPELERIA_PRODUCTS_SUBCATEGORIES_UPDATE', response)
      window.history.back()
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const papeleriaProductsSubCategoriesDelete = (context, payload) => {
  let obj = JSON.parse(payload)
  let url = 'inventory/products/subcategories/' + obj.id
  return fetchApi(url, payload, 'DELETE')
    .then((response) => {
      context.commit('PAPELERIA_PRODUCTS_SUBCATEGORIES_DELETE', response)
      location.reload()
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const papeleriaProductsSubcategories = (context, payloadId) => {
  let url = 'inventory/products/categories/' + payloadId + '/subs'
  let data = {}
  return fetchApi(url, data, 'GET')
    .then((response) => {
      context.commit('PAPELERIA_PRODUCTS_SUBCATEGORIES', response)
      let json = response.data
      var s = document.querySelector('[name=idSubCategory]')
      s.innerHTML = ''
      s.options[s.options.length] = new Option('Seleccione una opcion', null)
      for (var i = 0; i < json.length; i++) {
        s.options[s.options.length] = new Option(json[i].name, json[i].id)
      }
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const papeleriaProductsSubcategoriesAll = (context, payloadId) => {
  let url = 'inventory/products/categories/' + payloadId + '/subs'
  let data = {}
  return fetchApi(url, data, 'GET')
    .then((response) => {
      context.commit('PAPELERIA_PRODUCTS_SUBCATEGORIES', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const papeleriaProductsFilterSubCategories = (context, payloadId) => {
  let url = 'inventory/products/subcategories/' + payloadId + '/products'
  let data = {}
  return fetchApi(url, data, 'GET')
    .then((response) => {
      context.commit('PAPELERIA_PRODUCTS_FILTER_SUBCATEGORIES', response)
      let json = response.data
      var s = document.querySelector('[name=idSubCategory]')
      s.innerHTML = ''
      s.options[s.options.length] = new Option('Seleccione una opcion', null)
      for (var i = 0; i < json.length; i++) {
        s.options[s.options.length] = new Option(json[i].name, json[i].id)
      }
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const papeleriaProductsFilterSubCategoriesAll = (context, payloadId) => {
  let url = 'inventory/products/subcategories/' + payloadId + '/products'
  let data = {}
  return fetchApi(url, data, 'GET')
    .then((response) => {
      context.commit('PAPELERIA_PRODUCTS_FILTER_SUBCATEGORIES', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

export default {
  papeleriaProductsSubCategoriesAll,
  papeleriaProductsSubCategoriesForm,
  papeleriaProductsSubCategoriesShow,
  papeleriaProductsSubCategoriesCreate,
  papeleriaProductsSubCategoriesUpdate,
  papeleriaProductsSubCategoriesDelete,
  papeleriaProductsSubcategories,
  papeleriaProductsSubcategoriesAll,
  papeleriaProductsFilterSubCategories,
  papeleriaProductsFilterSubCategoriesAll
}



// WEBPACK FOOTER //
// ./src/store/modules/papeleria/products/subcategories/actions.js